export enum AuthState {
  Authenticated,
  NotAuthenticated,
  Pending
}
